import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { BsGithub } from "react-icons/bs";
import { SiUpwork } from "react-icons/si";

function HeaderSocials() {
  return (
    <div className="header__socials">
      <a href="https://linkedin.com" target="_blank">
        <BsLinkedin size={25} />
      </a>
      <a href="https://github.com" target="_blank">
        <BsGithub size={25} />
      </a>
      <a href="https://www.upwork.com" target="_blank">
        <SiUpwork size={25} />
      </a>
    </div>
  );
}

export default HeaderSocials;
